"use client";

import { useEffect } from "react";
import { detectBrand } from "@/definitions/brand";

export const DynamicFavicon = () => {
  useEffect(() => {
    const brand = detectBrand();
    const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (link) {
      link.href = brand.favicon;
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = brand.favicon;
      document.head.appendChild(newLink);
    }
  }, []);

  return null;
};
